import React from 'react';

export default (props) => {
  return (
    <input type='checkbox' disabled={true} checked={props.data[props.property]}/>
  );
};
